<div class="section is-fullheight" id="home">
  <div class="container has-text-centered">
    <Heading />
  </div>

  <div class="container has-text-centered">
    <div
      class="column is-8-tablet is-6-desktop is-offset-2-tablet is-offset-3-desktop"
    >
      <div class="box mt-2">
        <ul class="steps is-horizontal has-content-centered">
          {#each registerSteps as item, index}
            <li class="steps-segment {currentStep == index ? 'is-active' : ''}">
              <span
                class="steps-marker {currentStep == index ? 'is-hollow' : ''}"
              >
                <span class="icon"> <i class="fa fa-{item.icon}"></i> </span>
              </span>
              <div class="steps-content mb-4">
                <!-- <p class="is-size-5 is-size-6-mobile">{item.title}</p> -->
              </div>
            </li>
          {/each}
        </ul>
        <form
          on:submit|preventDefault="{formSubmit}"
          on:keydown="{handleFormKeyPress}"
        >
          {#if currentStep == 0}
            <div class="field">
              <div class="label is-large">Dein Einladungscode</div>
              <div class="control">
                <input
                  class="input is-large has-background-white-ter"
                  type="text"
                  style="text-transform: uppercase;"
                  placeholder="CODE"
                  bind:value="{userdata.code}"
                  on:keyup="{resetError}"
                  disabled="{processingLogin}"
                  data-testid="code"
                />
              </div>
              <p class="mt-3">
                Diesen Code erhältst du bei der Anmeldung zur Platzreife von
                deinem Golfclub.
              </p>
            </div>
          {/if}

          {#if currentStep == 1}
            <div class="field">
              <div class="label is-large">Deine E-Mail Adresse</div>
              <p class="control has-icons-left">
                <!-- has-icons-right -->
                <input
                  class="input is-large has-background-white-ter"
                  type="email"
                  placeholder="Email"
                  bind:value="{userdata.email}"
                  on:keyup="{resetError}"
                  autofocus=""
                  disabled="{processingLogin}"
                  data-testid="email"
                />
                <span class="icon is-small is-left">
                  <i class="fas fa-envelope"></i>
                </span>
                <!-- <span class="icon is-small is-right">
                <i class="fas fa-check"></i>
              </span> -->
              </p>
              <p class="mt-3">
                Nutze diese später zum Einloggen. Auf diese Adresse erhältst du
                auch einen Link zum Setzen deines Passworts.
              </p>
            </div>
            <!-- <div class="field">
            <p class="control has-icons-left">
              <input class="input is-large has-background-white-ter" type="password" placeholder="Passwort" bind:value={userdata.password} autofocus="" disabled={processingLogin}>
              <span class="icon is-small is-left">
                <i class="fas fa-lock"></i>
              </span>
            </p>
          </div> -->
          {/if}

          {#if currentStep == 2}
            <div class="field">
              <div class="label is-large">Deine persönlichen Daten</div>
              <p class="control has-icons-right">
                <input
                  class="input is-large has-background-white-ter"
                  type="text"
                  placeholder="Vorname"
                  bind:value="{userdata.firstname}"
                  on:keyup="{resetError}"
                  autofocus=""
                  disabled="{processingLogin}"
                  data-testid="firstname"
                />
              </p>
            </div>
            <div class="field">
              <p class="control">
                <input
                  class="input is-large has-background-white-ter"
                  type="text"
                  placeholder="Nachname"
                  bind:value="{userdata.lastname}"
                  on:keyup="{resetError}"
                  autofocus=""
                  disabled="{processingLogin}"
                  data-testid="lastname"
                />
              </p>
            </div>

            <div class="field">
              <p class="control">
                <input
                  class="input is-large has-background-white-ter"
                  type="text"
                  placeholder="Rufname"
                  bind:value="{userdata.nicename}"
                  on:keyup="{resetError}"
                  autofocus=""
                  disabled="{processingLogin}"
                  data-testid="nicename"
                />
              </p>
              <p class="mt-3">
                Mit dem Rufnamen wirst du innerhalb dieser Platzreifeplattform
                angesprochen.
              </p>
            </div>
          {/if}

          {#if currentStep == 3}
            <div class="field">
              <div class="label is-large">Rechtliches</div>
              <div class="checkboxes mt-5">
                <div>
                  <input
                    type="checkbox"
                    bind:checked="{userdata.disclaimer}"
                    on:click="{resetError}"
                    autofocus=""
                    disabled="{processingLogin}"
                    data-testid="disclaimer"
                  />
                </div>
                <label class="is-size-5 has-text-left">
                  Ja, ich bin mit der Verarbeitung meiner Daten im Zuge der
                  Platzreifeprüfung und der künftigen Kommunikationsplattform
                  einverstanden.
                  <a on:click="{() => '/datenschutz'}">Datenschutzerklärung</a>
                  anzeigen.
                </label>
              </div>
            </div>
          {/if}

          {#if currentStep == 4}
            <div class="field">
              <div class="label is-large" data-testid="register-headline">
                Glückwunsch
              </div>
              <p class="is-size-5">
                Du erhältst nun eine E-Mail zum Setzen deines Passwortes und
                kannst dich anschließend mit deinen Zugangsdaten einloggen um
                die theoretische Platzreifeprüfung zu beginnen.
              </p>
            </div>
          {/if}

          {#if error}
            {#if error == 'USER_EXISTS'}
              <div
                class="has-background-danger-light has-text-danger p-3 pl-4 has-text-left"
                data-testid="error-user-exists"
              >
                Diese E-Mail ist bereits registriert.
                <br />
                <a
                  class="has-text-danger has-text-bold"
                  on:click="{() => push('/passwort')}"
                >Passwort vergessen?</a>
                oder
                <a
                  class="has-text-danger has-text-bold"
                  on:click="{() => push('/login')}"
                >logge dich ein</a>
              </div>
            {:else}
              <div
                class="has-background-danger-light has-text-danger p-3 pl-4 has-text-left"
                data-testid="error-msg"
              >
                {error}
              </div>
            {/if}
          {/if}

          <div
            class="is-flex is-flex-direction-row is-justify-content-space-between"
          >
            {#if currentStep < registerSteps.length - 1}
              {#if currentStep == 0}
                <a
                  class="button mt-5 is-inverted is-medium {processingLogin ? 'is-loading' : ''}"
                  on:click="{() => push('/login')}"
                  disabled="{processingLogin}"
                  data-testid="button-login"
                >Zum Login</a>
              {/if}
              {#if currentStep !== 0}
                <a
                  class="button mt-5 is-inverted is-medium {processingLogin ? 'is-loading' : ''}"
                  on:click="{stepBack}"
                  data-testid="button-prev"
                  disabled="{processingLogin}"
                >Zurück</a>
              {/if}
              <a
                class="button mt-4 is-outlined is-large {processingLogin ? 'is-loading' : ''}"
                on:click="{stepNext}"
                disabled="{error || processingLogin}"
                data-testid="button-next"
              >{stepData.nextLabel ? stepData.nextLabel : 'Weiter'}</a>
            {:else}
              <a
                class="button mt-4 is-outlined is-large is-fullwidth"
                on:click="{() => push('/login')}"
              >Zum Login</a>
            {/if}
          </div>
        </form>
      </div>
    </div>
  </div>
  <FooterNav />
</div>

<script>
import { push } from "svelte-spa-router";
import FooterNav from "./FooterNav.svelte";
import Heading from "./Heading.svelte";
import { authSvc, demoSvc } from "./services";
import { club } from "./stores";

let clubData,
  userdata = {},
  error,
  success,
  processingLogin;
const isDemo = demoSvc.isDemoInstance();

if (!isDemo && location.href.indexOf("/golfclub-musterstadt/") !== -1) {
  // userdata.code = 'JNAGNT'; // DEV
  // userdata.code = 'VQMEFL'; // LIVE
  // userdata.email = 'm+spieler2@edenhauser.com';
  // userdata.firstname = 'Dev';
  // userdata.lastname = 'Spieler';
  // userdata.nicename = 'Spieler';
}

const registerSteps = [
  {
    icon: "play",
    isActive: () => !userdata.code,
    onNext: async () => {
      if (userdata.code !== clubData.invitecode) {
        error = "Ungültigen Code eingegeben, bitte versuche es erneut.";
        return false;
      }
      return true;
    },
  },
  {
    icon: "lock",
    // isActive: () => !userdata.email || !userdata.password
    isActive: () => !userdata.email,
    onNext: async () => {
      if (!userdata.email) {
        error = "Bitte gebe eine gültige E-Mail ein.";
        return false;
      }
      return true;
    },
  },
  {
    icon: "user",
    isActive: () =>
      !userdata.firstname || !userdata.lastname || !userdata.nicename,
    onNext: async () => {
      if (!userdata.firstname || !userdata.lastname || !userdata.nicename) {
        error = "Bitte fülle alle Felder aus";
        return false;
      }
      return true;
    },
  },
  {
    icon: "cog",
    isActive: () => !userdata.disclaimer,
    onNext: async () => {
      if (!userdata.disclaimer) {
        error = "Bitte bestätige die Einwilligung zur Datenverarbeitung.";
        return false;
      }
      return await formSubmit();
    },
    nextLabel: "Abschließen",
  },
  {
    icon: "check",
    isActive: () => !userdata.disclaimer,
  },
];

let currentStep = registerSteps.map((s) => s.isActive()).indexOf(true);
$: stepData = registerSteps[currentStep];

const resetError = () => (error = null);

const stepBack = () => {
  currentStep--;
};
const stepNext = async () => {
  const onNext = registerSteps[currentStep].onNext;
  if (!onNext) {
    currentStep++;
    return;
  }
  await onNext().then((valid) => {
    if (valid) {
      currentStep++;
    }
  });
};
const formSubmit = () => {
  processingLogin = true;
  return authSvc.register(userdata).then((result) => {
    processingLogin = false;
    if (result.error) {
      error = result.error;
      return false;
    }
    return true;
  });
};

const handleFormKeyPress = (e) => {
  if (e.key === "Enter") {
    e.preventDefault();
    !error && !processingLogin && stepNext();
  }
};

club.subscribe((data) => (clubData = data));
</script>

<style type="text/scss">
.has-text-bold {
  font-weight: bold;
}
.checkboxes {
  display: flex;
}
input[type="checkbox"] {
  height: 20px;
  width: 20px;
  vertical-align: middle;
  margin-right: 10px;
  margin-top: 2px;
}

.notification p {
  font-weight: 400;
}

.box {
  margin-top: 5rem;
}
input {
  font-weight: 300;
}
p {
  font-weight: 700;
}
p.subtitle {
  padding-top: 1rem;
}

.login-hr {
  border-bottom: 1px solid black;
}

.has-text-black {
  color: black;
}

.field {
  padding-bottom: 10px;
}

.fa {
  margin-left: 5px;
}
</style>
